import dynamic from 'next/dynamic'
import { RichTextEntries } from '@/interfaces/contentType'

export const RTEmbeddedEntriesMapping: {
  [key in RichTextEntries]?: React.ComponentType<any>
} = {
  [RichTextEntries.Quote]: dynamic(() => import('@/components/Quote')),
  [RichTextEntries.Table]: dynamic(() => import('@/components/Table')),
}
